import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

// YouTube/Vimeo only, lazy-loaded (docs/01-PRODUCT-SPEC.md §3.2). Restricting the host at the
// schema level keeps an arbitrary third-party iframe out of a page that collects personal data.
const configSchema = z.object({
  url: z
    .string()
    .url()
    .refine(
      (value) => /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be|vimeo\.com)\//.test(value),
      "Only YouTube and Vimeo URLs are supported",
    )
    .optional(),
  caption: z.string().max(300).optional(),
});

export const videoEmbedField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "video_embed",
  label: "Video",
  category: "layout",
  icon: "Video",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: {},
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
